<template>
  <div style="padding-top: 50px">
    <img :src="classDetail.image_url" class="img-banner" />
    <div class="detail-body">
      <div class="container">
        <div class="d-flex" style="justify-content: center; flex-wrap: wrap; margin: 20px; gap: 10px">
          <div class="btn-white-oval font-poppins">{{ classDetail.type }}</div>
          <div class="btn-brown-oval font-poppins">{{ classDetail.class_type }}</div>
          <div class="btn-yellow-oval font-poppins">{{ toMethode(classDetail.method) }}</div>
        </div>
        <div class="text-center">
          <h3 class="sub-title-span">
            {{ classDetail.name }}
          </h3>
          <div class="information">
            <h3 class="sub-title-span">
              {{ classDetail.batch }}
            </h3>
            <p v-if="classDetail.schedules.length" style="font-size: 15px">{{
              formatDate(classDetail.schedules[0].start_date) }} - {{
                formatDate(classDetail.schedules[0].end_date) }}</p>
            <div v-if="classDetail.is_discount && classDetail.label_discount" style="
                  font-size: 10px;
                  border: 1px solid black;
                  border-radius: 30px;
                  width: fit-content;
                  padding: 4px 12px 4px 12px;
                  margin: auto;
                ">
              {{ classDetail.label_discount }}
            </div>
            <div class="schedule-desc">
              <div class="schedule-content">
                <Star fill="gray" />
                <p class="text"> {{ classDetail.level }}</p>
              </div>
              <div class="schedule-content" v-if="classDetail.schedules.length">
                <person />
                <p class="text">{{ classDetail.schedules[0].total_audience }} {{
                  $t('corpAcelerationDetail.header.totalAudience') }}</p>
              </div>
              <div class="schedule-content" v-if="classDetail.schedules.length">
                <calendar />
                <p class="text">{{ classDetail.schedules[0].session }} {{ $t('corpAcelerationDetail.header.session') }}
                </p>
              </div>
            </div>
          </div>
          <v-btn depressed color="#FFDE59" @click="goToCheckoutPage()" class="button-daftar" v-if="!isRegistrantClose">
            <span class="text-capitalize font-weight-bold blue-text">{{
              $t('corporate.heroSection.ctaButtons.registerNow') }}</span>
          </v-btn>
          <v-btn depressed color="#FFFFFF" @click="sendToWa" class="button-daftar" style="border: 1px solid">
            <span class="text-capitalize font-weight-bold blue-text">{{
              $t('corporate.heroSection.ctaButtons.consultationFirst') }}</span>
          </v-btn>
          <div class="collab">
            <p class="text">{{ $t('corpAcelerationDetail.header.a1') }}</p>
            <div class="img-collab">
              <img :src="classDetail.collaboration_feed" alt="" />
            </div>
          </div>
        </div>
        <div class="mt-10">
          <span style="font-size: 14px">{{ $t('corpAcelerationDetail.infoSection.infoClass.title') }}</span>
          <h3>{{ $t('corpAcelerationDetail.infoSection.infoClass.subTitle') }}</h3>
          <p class="desc-program mt-3">{{ classDetail.description }}</p>
        </div>
      </div>
      <div class="bg-container">
        <div style="margin-top: 45px; padding: 40px 0px">
          <span>{{ $t('corpAcelerationDetail.infoSection.syllabus.title') }}</span>
          <h5 class="title mb-4" style="
                font-family: 'Poppins', sans-serif !important;
                line-height: 25px;
              ">
            {{ $t('corpAcelerationDetail.infoSection.syllabus.subTitle') }}
          </h5>
          <div v-for="(item, idx) in classDetail.summary_syllabus" :key="idx" class="faq-box"
            @click="toggleSyllabus(idx, item.name)">
            <div class="fax-box-info">
              <p style="width: 90%">{{ item.name }}</p>
              <Arrow :down="item.show" fill="#36373f" />
            </div>
            <p v-if="item.show" class="faq-box-active" v-html="item.value"></p>
          </div>
        </div>
      </div>

      <div class="container-parent-grdn radius">
        <div class="container">
          <div class="benefits-container">
            <span>{{ $t('corpAcelerationDetail.infoSection.benefits.title') }}</span>
            <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('corpAcelerationDetail.infoSection.benefits.subTitle') }}
            </h5>
            <div class="benefits" v-for="(item, idx) in classDetail.benefits" :key="idx">
              <CheckIc :width="26" :height="26" outline fill="#575966" />
              <span>{{ item }}</span>
            </div>
          </div>

          <div class="objectives-container mt-5">
            <span>{{ $t('corpAcelerationDetail.infoSection.trainingObjectives.title') }}</span>
            <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('corpAcelerationDetail.infoSection.trainingObjectives.subTitle') }}
            </h5>
            <div class="objectives" v-html="classDetail.learning_objective"></div>
          </div>

          <div class="target-audience-container mt-5">
            <span>{{ $t('corpAcelerationDetail.infoSection.targetAudience.title') }}</span>
            <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('corpAcelerationDetail.infoSection.targetAudience.subTitle') }}
            </h5>
            <div class="target" v-for="(item, idx) in classDetail.target_audience" :key="idx">
              <CheckIc :width="26" :height="26" outline fill="#575966" />
              <span>{{ item.level }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <h5 class="title mt-5" style="
              font-family: 'Poppins', sans-serif !important;
              line-height: 25px;
              text-align: center;
            ">
          {{ $t('corpAcelerationDetail.whyHiColleagues.title') }}
        </h5>
        <div class="card-hicol" v-for="(item, idx) in $t('corpAcelerationDetail.whyHiColleagues.items')" :key="idx">
          <div class="circle-yellow">
            <img :src="item.img" width="28" alt="Ctn" />
          </div>
          <div style="width: 80%">
            <h3 style="font-size: 15px">{{ item.title }}</h3>
            <p style="font-size: 12px">{{ item.desc }}</p>
          </div>
        </div>
        <!-- <span>{{ $t('corpAcelerationDetail.learningMethod.additionalTitle') }}</span>
        <h5 class="title" style="
              line-height: 25px;
              margin-bottom: 20px;
              font-family: 'Poppins', sans-serif !important;
            ">
          {{ $t('corpAcelerationDetail.learningMethod.title') }}
        </h5>
        <div v-for="(item, idx) in $t('corpAcelerationDetail.learningMethod.items')" :key="idx"
          style="display: flex; gap: 10px; margin-top: 10px">
          <div class="circle-yellow">
            <img :src="item.img" width="28" alt="Ctn" />
          </div>
          <div style="width: 80%">
            <h3 style="font-size: 15px">{{ item.title }}</h3>
            <p style="font-size: 12px">{{ item.desc }}</p>
          </div>
        </div> -->
        <br />

        <div class="container-parent mt-10" ref="timeline_belajar">
          <div class="container-detail">
            <span class="addional">{{ $t('corpAcelerationDetail.scheduleSection.schedule') }}</span>
            <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('corpAcelerationDetail.scheduleSection.schedule2') }}
            </h5>
            <div class="timeline-bootcamp mt-5" v-for="(item, idx) in classDetail.schedules" :key="idx">
              <div style="padding: 20px">
                <div class="batch-alert d-flex justify-content-between">
                  <p class="batch">{{ $t('corpAcelerationDetail.scheduleSection.batch') }} {{ item.batch_number }}</p>
                  <div class="alert-early" v-if="classDetail.is_discount">
                    {{ $t('corpAcelerationDetail.scheduleSection.discountLabel') }}
                  </div>
                </div>

                <p class="schedule">
                  {{ formatDate(item.start_date) }} -
                  {{ formatDate(item.end_date) }}
                </p>
              </div>
              <div class="line"></div>
              <div class="info-schadule-top">
                <v-row>
                  <v-col>
                    <div class="info-schadule-ctn">
                      <GrowIc :width="25" fill="#7B7E8C" />
                      <span>{{ classDetail.level }}</span>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="info-schadule-ctn">
                      <DateIc :width="25" fill="#7B7E8C" />
                      <span>{{ item.session }} {{ $t('corpAcelerationDetail.scheduleSection.infoSchedule.totalAudience')
                      }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <div class="info-schadule-ctn">
                      <PeopleIc :width="25" fill="#7B7E8C" />
                      <span>{{ item.total_audience }} {{
                        $t('corpAcelerationDetail.scheduleSection.infoSchedule.session') }}</span>
                    </div>
                  </v-col>

                  <v-col>
                    <div class="info-schadule-ctn">
                      <MethodeIc :width="25" fill="#7B7E8C" />
                      <span>{{ classDetail.method | toMethode }}</span>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <img src="/img/icons/line-strip.png" alt="Link" style="width: 100%" />
              <div class="info-schadule-bot mb-4" style="display: block">
                <v-row>
                  <v-col>
                    <div class="info-schadule-ctn d-flex">
                      <ClockIc :width="25" fill="#7B7E8C" />
                      <span style="padding-top: -10px">{{ $t('corpAcelerationDetail.scheduleSection.executionTime')
                      }}</span>
                    </div>
                    <ul class="shadule">
                      <li>
                        <div style="display: flex; gap: 20px; align-items: center">
                          <span class="font-poppins">{{
                            classDetail.days
                          }}</span>
                          <span>:</span>
                          <span class="font-poppins">{{
                            classDetail.hours
                          }}</span>
                        </div>
                      </li>
                    </ul>
                  </v-col>
                  <div class="box-price">
                    <div class="early-bird">
                      <div class="price-title-eb" v-if="classDetail.is_discount">
                        <h3 class="eb">{{ classDetail.label_discount }}</h3>
                      </div>
                      <div class="price-title-nm" v-else>
                        <h3 class="np">{{ $t('corpAcelerationDetail.scheduleSection.pricing.normalPrice') }}</h3>
                      </div>
                      <div class="price-content">
                        <div class="discount-hide" v-if="classDetail.is_discount">
                          <span style="
                                text-decoration: line-through;
                                color: #b80f0a;
                                font-size: 12px;
                                margin-bottom: 6px;
                              ">{{ classDetail.price | toCurrency }}</span>
                        </div>
                        <h1 v-if="classDetail.is_discount" style="
                              color: #162ca2;
                              font-size: 16px;
                              margin-bottom: 6px;
                            ">
                          {{ toCurrency(classDetail.price - classDetail.discount_price) }}
                        </h1>
                        <h1 style="
                              color: #162ca2;
                              font-size: 16px;
                              margin-bottom: 6px;
                              margin-top: 0px;
                              padding: 0px 0px 20px;
                            " v-else>
                          {{ classDetail.price | toCurrency }}
                        </h1>

                        <span class="sampai-tanggal" v-if="classDetail.is_discount">{{
                          $t('corpAcelerationDetail.scheduleSection.pricing.validFrom') }}
                          {{ formatDate(classDetail.end_discount_date) }}</span>
                      </div>
                    </div>
                    <p style="text-align: center; margin-top: 6px">
                      {{ $t('corpAcelerationDetail.scheduleSection.registrationCloseDate') }}
                      <span style="
                            color: #b80f0a;
                            font-size: 10px;
                            font-weight: 700;
                          ">{{ formatDate(classDetail.registration_close_date) }}</span>
                    </p>
                  </div>

                  <v-col style="display: flex; justify-content: center">
                    <v-btn depressed color="#162CA2" @click="goToCheckoutPage(item)" class="button-daftar"
                      v-if="!isRegistrantClose">
                      <span class="text-capitalize font-weight-bold white-text font-poppins">DAFTAR SEKARANG</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-container" style="margin-bottom: 0px">
        <div style="margin-top: 45px; padding: 40px 0px">
          <h5 class="title mb-4" style="
                font-family: 'Poppins', sans-serif !important;
                line-height: 25px;
                text-align: center;
                font-size: 18px;
              ">
            Frequently Asked Question
          </h5>
          <v-expansion-panels flat class="faq-card">
            <v-expansion-panel style="border-radius: 20px; margin-bottom: 10px;" v-for="(item, index) in questions"
              :key="index">
              <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)" style="border-radius: 20px;">
                <h3 style="font-size: 14px; line-height: 20px;">{{ item.title }}</h3>
                <template v-slot:actions>
                  <div class="icon" v-if="item.active" style="margin-right: 20px;">
                    <Arrow />
                  </div>
                  <div v-else>
                    <Arrow :down="!item.active" />
                  </div>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="border-radius:0 0 20px 20px; margin-left: 10px;">
                <div style="font-size: 12px;" v-html="item.description"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import CheckIc from "@/assets/icons/Check.vue";
import Star from "@/assets/icons/Star.vue";
import Arrow from "@/assets/icons/Arrow.vue";
import Person from "@/assets/icons/Person.vue";
import Calendar from "@/assets/icons/Calendar.vue";
import ClockIc from "@/assets/icons/Clock.vue";
import MethodeIc from "@/assets/icons/Methode.vue";
import DateIc from "@/assets/icons/Date.vue";
import GrowIc from "@/assets/icons/Grow.vue";
import PeopleIc from "@/assets/icons/People.vue";

export default {
  name: "DetailClassaccelerationMobile",
  components: {
    CheckIc,
    Star,
    Person,
    Calendar,
    Arrow,
    ClockIc,
    MethodeIc,
    DateIc,
    GrowIc,
    PeopleIc,
  },
  data() {
    return {
      priceAddInfo: [
        "Tipe kelas Public",
        "Kapasitas max 10 peserta",
        "Jadwal kelas telah ditentukan",
        "Diajarkan langsung oleh mentor",
        "Gratis Survival Kit",
        "Sertifikat Kelulusan",
      ],
      classDetail: {
        summary_syllabus: [],
        benefits: [],
        learning_objective: [],
        target_audience: [],
        price: 0,
        is_discount: false,
        discount_price: 0,
        end_discount_date: "",
        schedules: [],
        level: "",
        days: "",
        hours: "",
      },
      alertErrMessage: "",
      isAlertErr: false,
      isRegistrantClose: false,
      questions: [],
      expired: [],
      layout: "info-kelas",
    };
  },
  metaInfo() {
    return {
      title: `HiColleagues | ${this.classDetail.name}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.classDetail.meta_description}`
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `HiColleagues | ${this.classDetail.name}`
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: `${this.classDetail.meta_description}`
        }
      ]
    }
  },
  watch: {
    "$i18n.locale"() {
      this.getDetailClass();
      this.getFaq();
    },
  },
  methods: {
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === "online") {
        return this.$i18n.locale === 'id' ? "Daring (via Zoom)" : "Online (via Zoom)";
      } else if (value.toLowerCase() === "offline") {
        return this.$i18n.locale === 'id' ? "Luring" : "Offline";
      } else {
        return value;
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Free Consultation - WhatsApp - Mobile',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      if (value <= 0) {
        return "FREE";
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },
    goToCheckoutPage(schedule) {
      if (this.isRegistrantClose) {
        this.alertErrMessage = "Pendaftaran sudah ditutup";
        this.isAlertErr = true;
        return;
      }
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Register Now - ${this.classDetail.name} - Mobile`,
        value: 1,
      });
      if (!schedule) {
        schedule = this.classDetail.schedules[0];
      }
      const req = JSON.stringify({
        class_id: this.classDetail.class_id,
        class_name: this.classDetail.name,
        price: this.classDetail.price,
        level: this.classDetail.level,
        session: this.classDetail.session_total,
        hour: this.classDetail.hours,
        image_url: this.classDetail.small_image_url,
        class_type: "ACCELERATION_CLASS",
        type: this.classDetail.type,
        type_class: this.classDetail.class_type,
        is_discount: this.classDetail.is_discount,
        discount_price: this.classDetail.discount_price,
        collaboration_feed: this.classDetail.collaboration_feed,
        schedule: schedule,
        days: this.classDetail.days,
        methode: this.classDetail.method,
        category_id: this.classDetail.category_id,
      });
      localStorage.setItem("checkout", req);
      this.$router.push("/certification/checkout");
    },
    async getDetailClass() {
      await this.$http
        .get(`/v1/class-detail/${this.$route.params.slug_name}`)
        .then((response) => {
          const data = response.data.data.class_detail;
          this.classDetail = {
            ...data,
            summary_syllabus: data.summary_syllabus
              ? data.summary_syllabus.map((item) => ({
                ...item,
                show: true,
              }))
              : [],
          };
          this.isRegistrantClose = new Date(this.classDetail.registration_close_date) <= new Date();
        })
        .catch((err) => console.error(err));
    },
    toggleSyllabus(index, name) {
      this.$gtag.event('click', {
        event_category: 'Syllabus',
        event_label: `Toggle Syllabus - ${name} - Mobile`,
        value: 1,
      });
      this.classDetail.summary_syllabus[index].show = !this.classDetail.summary_syllabus[index].show;
    },
    openFaq(index, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title} - Mobile`,
        value: 1,
      });
      const valDef = this.questions[index].active;
      this.questions.forEach((e) => {
        e.active = false;
      });
      this.questions[index].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=CLASS_ACCELERATION&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false
        }));
      } catch (err) {
        console.log(err);
      }
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
  },
  mounted() {
    this.getDetailClass();
    this.getFaq();
    window.scrollTo(0, 0);
  },
};
</script>
<style src="./detailClassAcceleration.css" scoped></style>